export const _setStagedEmployeeDocuments = (state, action) => action.payload;
